// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseList from "../../../../../engines/components/BaseList";
import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../../engines/gameEngine";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import MansionsBuildItem from "./MansionsBuildItem";

const {ccclass, property} = cc._decorator;

@ccclass
export default class MansionsBuildLayer extends BasePopUpLayer {

    @property(cc.ScrollView)
    scrollView: cc.ScrollView = null;


    private itemArray: string[] = [];

    private csvInfos: any = null;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.initLayer();
    }

    initLayer() {
        let csvInfos = this.csvInfos = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.MANSION_BUILD);
        if (!csvInfos) {
            console.error(`未找到表格数据 MANSION_BUILD`);
            return;
        }

        this.initScroll();
    }

    initScroll() {
        let content = this.scrollView.content;
        content.removeAllChildren();
        
        for (let i in this.csvInfos) {
            if (i == 'title' || i == '' || i.trim() == '') {
                continue;
            }
            this.itemArray.push(i);
        }

        let list = this.scrollView.getComponent(BaseList);
        list.numItems = this.itemArray.length;
    }

    renderItem(scroll: BaseList, item, idx: number) {
        let array = this.itemArray;
        let data = array[idx];
        let itemScript: MansionsBuildItem = item.getComponent(MansionsBuildItem);
        itemScript.setData(
            this
            , data
        );
    }

    refreshList() {
        let list = this.scrollView.getComponent(BaseList);
        list.numItems = this.itemArray.length;
    }
    
    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.destroyNode();
    }

    // update (dt) {}
}
